import { DOCUMENT } from "@angular/common";
import {
    AfterViewChecked,
    ChangeDetectionStrategy,
    Component,
    Inject,
} from "@angular/core";
import { Store } from "@ngrx/store";

import { LayoutFacade } from "@hermes/aphrodite/layout";
import {
    StoryState,
    selectStoryParagraphs,
    selectStoryimmersiveContentColor,
} from "@hermes/states/story-state";

const NUMBER_OF_PARAGRAPHS_TO_PRELOAD: number = 2;

@Component({
    selector: "h-story-blocks-container",
    templateUrl: "./story-blocks-container.component.html",
    styleUrls: ["./story-blocks-container.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoryBlocksContainerComponent implements AfterViewChecked {
    public paragraphs$ = this.storyStore.select(selectStoryParagraphs);
    public immersiveContentColor$ = this.storyStore.select(
        selectStoryimmersiveContentColor,
    );

    constructor(
        public layoutFacade: LayoutFacade,
        private storyStore: Store<StoryState>,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    public ngAfterViewChecked(): void {
        if (this.document.documentElement.scrollLeft > 0) {
            this.document.documentElement.scroll({ left: 0 });
        }
    }

    // Should only preload first or second block with media in them
    public shouldPreloadMedia(index: number): boolean {
        return index < NUMBER_OF_PARAGRAPHS_TO_PRELOAD;
    }
}
